module.exports = __webpack_public_path__ + "img/huawuIcon3.582bfd66.png";